import { Stack } from 'react-bootstrap'
import type { ReactNode } from 'react'
import type { UsageListProviderProps } from './Context'
import type { UsageListProps } from './UsageList'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { UsageListProvider, useUsageListContext } from './Context'
import { UsageList } from './UsageList'
import { UsageListDataTool } from './UsageListDataTool'
import { UserFilter } from './UserFilter'

const UserFilterSlot = () => {
  const { byUser } = useUsageListContext()
  return (
    <ShowIf condition={byUser}>
      <UserFilter />
    </ShowIf>
  )
}

type UsageTableProps = Omit<UsageListProviderProps, 'children'> &
  UsageListProps & {
    // Leads the toolbar row, opposite the filters — the balance hero or a standalone action.
    toolbarStart?: ReactNode
    // Rendered inside the list provider, for a panel that reads the table's context.
    children?: ReactNode
  }

// The AI usage table shared by every app that shows `aiCreditTransactionList`. `billingScope` is the
// app's own `IAiUsageConfig.billingScope`: Tenant adds the user column and the per-user filter,
// User shows the rows as its query returns them.
export const UsageTable = ({ toolbarStart, onRowDoubleClick, height, children, ...providerProps }: UsageTableProps) => (
  <UsageListProvider {...providerProps}>
    <Stack gap={3}>
      <HorizontalStack gap={3} className="align-items-start justify-content-between">
        <div>{toolbarStart}</div>
        <HorizontalStack gap={2} className="align-items-start">
          <UserFilterSlot />
          <UsageListDataTool />
        </HorizontalStack>
      </HorizontalStack>

      <UsageList onRowDoubleClick={onRowDoubleClick} height={height} />
    </Stack>
    {children}
  </UsageListProvider>
)
